// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Container } from 'unstated';

import type { GenerateImageProps } from '@atlassian/ai-image-generation/types';

import { COVERPICTUREWIDTH } from '@confluence/content-topper/entry-points/contentTopperConstants.ts';

type CoverPictureStateContainerType = {
	hasCoverPicture: boolean;
	isUploadingPicture: boolean;
	isModalOpen: boolean;
	isRemovingPicture: boolean;
	isRepositioningPicture: boolean;
	isAddHeaderImageButtonFocused: boolean;
	coverPictureId: string;
	shouldShowReposition: boolean;
	isChangingPicture: boolean;
	coverPictureWidth: COVERPICTUREWIDTH;
	// AI Generated Image Acceptance Flow
	shouldShowAIImageAcceptanceFlow: boolean;
	lastAIGenerationParams: GenerateImageProps | null;
	// Tracks whether the current cover image was auto-generated during AIFC (Smart Create)
	isCurrentAIFCAutoImage: boolean;
};
export class CoverPictureStateContainer extends Container<CoverPictureStateContainerType> {
	state = {
		hasCoverPicture: false,
		isUploadingPicture: false,
		isModalOpen: false,
		isRemovingPicture: false,
		isRepositioningPicture: false,
		isAddHeaderImageButtonFocused: false,
		coverPictureId: '',
		shouldShowReposition: false,
		isChangingPicture: false,
		coverPictureWidth: COVERPICTUREWIDTH.FULL,
		shouldShowAIImageAcceptanceFlow: false,
		lastAIGenerationParams: null,
		isCurrentAIFCAutoImage: false,
	};

	setHasCoverPicture = (hasCoverPicture: any): Promise<void> => this.setState({ hasCoverPicture });
	toggleCoverPictureWidthButton = (coverPictureWidth: COVERPICTUREWIDTH): Promise<void> =>
		this.setState({ coverPictureWidth });
	setCoverPictureId = (coverPictureId: any): Promise<void> => this.setState({ coverPictureId });
	setIsUploadingPicture = (isUploadingPicture: any): Promise<void> =>
		this.setState({ isUploadingPicture });
	setIsModalOpen = (isModalOpen: any): Promise<void> => this.setState({ isModalOpen });
	setIsChangingPicture = (isChangingPicture: any): Promise<void> =>
		this.setState({ isChangingPicture });
	setIsRemovingPicture = (isRemovingPicture: any): Promise<void> =>
		this.setState({ isRemovingPicture });
	setIsRepositioningPicture = (isRepositioningPicture: any): Promise<void> =>
		this.setState({ isRepositioningPicture });
	setShouldShowReposition = (shouldShowReposition: any): Promise<void> =>
		this.setState({ shouldShowReposition });
	setIsAddHeaderImageButtonFocused = (isAddHeaderImageButtonFocused: any): Promise<void> =>
		this.setState({ isAddHeaderImageButtonFocused });
	setShouldShowAIImageAcceptanceFlow = (shouldShowAIImageAcceptanceFlow: any): Promise<void> =>
		this.setState({ shouldShowAIImageAcceptanceFlow });
	setLastAIGenerationParams = (lastAIGenerationParams: GenerateImageProps | null): Promise<void> =>
		this.setState({ lastAIGenerationParams });
	setIsCurrentAIFCAutoImage = (isCurrentAIFCAutoImage: boolean): Promise<void> =>
		this.setState({ isCurrentAIFCAutoImage });
	resetToDefaults = (): void => {
		void this.setIsModalOpen(false);
		void this.setIsAddHeaderImageButtonFocused(false);
		void this.setIsUploadingPicture(false);
		void this.setIsChangingPicture(false);
		void this.setIsRemovingPicture(false);
		void this.setShouldShowReposition(false);
		void this.toggleCoverPictureWidthButton(COVERPICTUREWIDTH.FULL);
		void this.setShouldShowAIImageAcceptanceFlow(false);
		void this.setLastAIGenerationParams(null);
		void this.setIsCurrentAIFCAutoImage(false);
	};
}
